import React from "react"
import PropTypes from "prop-types"
import { Col, Input, Label, Row } from "reactstrap"

const DoctorSelector = ({ doctors, selectedDoctorId, onChange, compact = false, label = "Doctor" }) => {
  if (!doctors.length) {
    return null
  }

  if (compact) {
    return (
      <div
        className="d-flex align-items-center gap-2 doctor-selector-inline"
        style={{ minWidth: "320px", maxWidth: "460px", width: "100%" }}
      >
        <span className="text-muted fw-medium flex-shrink-0">{label}</span>
        <Input
          type="select"
          value={selectedDoctorId}
          onChange={e => onChange(e.target.value)}
          style={{ minWidth: "220px" }}
        >
          {doctors.map(doctor => (
            <option key={doctor.id} value={doctor.id}>
              {doctor.display_name || doctor.name}
            </option>
          ))}
        </Input>
      </div>
    )
  }

  return (
    <Row className="mb-3">
      <Col md={6}>
        <Label className="form-label">{label}</Label>
        <Input type="select" value={selectedDoctorId} onChange={e => onChange(e.target.value)}>
          {doctors.map(doctor => (
            <option key={doctor.id} value={doctor.id}>
              {doctor.display_name || doctor.name}
            </option>
          ))}
        </Input>
      </Col>
    </Row>
  )
}

DoctorSelector.propTypes = {
  doctors: PropTypes.array.isRequired,
  selectedDoctorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  compact: PropTypes.bool,
  label: PropTypes.string,
}

export default DoctorSelector
